<template>
  <TheLayout>
    <LayoutCardDouble :fullWidth="true">
      <template #left>
        <div class="__box_left">
          <LayoutCardTitle>CHUYỂN ĐỔI DỮ LIỆU TỪ NEXTSHOP PHIÊN BẢN CŨ CHỈ VỚI 3 BƯỚC</LayoutCardTitle>
          <LayoutFieldSet>
            <div style="text-align: justify">
              Giúp bạn kết nối và chuyển đổi dữ liệu từ NextShop phiên bản cũ sang phiên bản hiện tại dễ dàng và đầy đủ nhất.
            </div>
          </LayoutFieldSet>
          <LayoutFieldSet style="margin-top: 32px">
            <div
              class="__box_step"
              v-for="(step, index) in listStep"
              :key="index"
              @click="changeStep(index)"
            >
              <div
                class="__box_step_index"
                :class="step.show ? 'active' : ''"
              >
                {{ index + 1 }}
              </div>
              <div class="__box_text">
                <div>
                  <div class="__box_step_title">{{ step.title }}</div>
                  <div class="__box_step_content" v-if="step.show">
                    <span v-if="index == 0">
                      <span style="color: #3E69F6" @click="linkToNexshopV1"> Bấm vào đây </span>
                      hoặc bấm vào nút
                      <span style="color: #3E69F6"  @click="linkToNexshopV1"> Liên kết ngay </span>
                      bên dưới để đăng nhập tài khoản phiên bản cũ. Điều này sẽ giúp chúng tôi xác minh được tài khoản và bắt đầu liên kết dữ liệu.
                    </span>

                    <span v-if="index == 1">
                      Sau khi đăng nhập thành công phiên bản cũ,
                      <span style="color: #3E69F6" @click="convertData()"> Bấm vào đây</span>
                      để bắt đầu chuyển đổi dữ liệu.
                    </span>

                    <span v-if="index == 2">
                      Thời gian chuyển đổi phụ thuộc vào độ lớn dữ  liệu của bạn. Trong lúc chờ đợi tiến trình hoàn thành, bạn có thể xem Hướng dẫn sử dụng phiên bản mới
                      <span style="color: #3E69F6" > tại đây</span>
                    </span>
                  </div>
                </div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="display: flex;align-items: center;height: 100%;"
                  v-if="!step.show"
                >
                  <path
                    d="M14.8438 12.2812C15 12.125 15 11.9062 14.8438 11.75L10.2812 7.125C10.125 6.96875 9.875 6.96875 9.75 7.125L9.125 7.75C8.96875 7.875 8.96875 8.125 9.125 8.28125L12.8125 12L9.125 15.75C8.96875 15.9062 8.96875 16.125 9.125 16.2812L9.75 16.9062C9.875 17.0625 10.125 17.0625 10.2812 16.9062L14.8438 12.2812Z"
                    fill="#C7C9D1"
                  />
                </svg>
              </div>
            </div>
          </LayoutFieldSet>
        </div>
      </template>
      <template #right>
        <img style="height: 432px, width: 502px" :src="imgCurrent" alt="" />
      </template>
    </LayoutCardDouble>

    <LayoutCard :fullWidth="true" class="maxWidth0">
      <LayoutCardTitle>THÔNG TIN CHUYỂN ĐỔI</LayoutCardTitle>
      <div style="margin: 0px 0px 20px 0px">
        {{ statusLink
          ? 'Liên kết tài khoản phiên bản cũ thành công.'
          : 'Hãy bắt đầu chuyển đổi đữ liệu bằng bước liên kết tài khoản.'
        }}
      </div>

      <BaseButton
        style="margin: 0px"
        @click="linkToNexshopV1()"
        v-if="!statusLink"
      >
        Liên kết ngay
      </BaseButton>

      <div class="__infor_convert" v-else>
       <div v-if="statusConvert">
          <div class="__infor_convert_text" >Tên cửa hàng hoặc doanh nghiệp: <span>{{ nameMerchant }}</span></div>
          <div class="__infor_convert_text" >Tài khoản cửa hàng: <span>{{ nameAccount }}</span></div>
          <div class="__infor_convert_text">Trạng thái: <span :class="checkStatusSync == 'COMPLETED' ? 'text-green' : 'text-danger'">{{ checkStatusSync | mapArrStatusSync }}</span></div>
       </div>
        <BaseButton v-if="statusLink && !statusConvert" @click="convertData()">Chuyển đổi ngay</BaseButton>
      </div>
    </LayoutCard>
    <div class="box-loading" v-show="loading">
      <div class="loading">
        <b-spinner variant="primary" label="Loading..." />
      </div>
    </div>
  </TheLayout>
</template>

<script>
import VueCookies from 'vue-cookies'
import { SettingService } from "@/services/nextshop/setting.service"
import Swal from "sweetalert2"

export default {
  data() {
    return {
      MID: VueCookies.get("MID"),
      imgCurrent: "",
      nameMerchant: "",
      nameAccount: "",
      statusLink: false,
      statusConvert: false,
      listStep: [
        {
          title: "Đăng nhập tài khoản phiên bản cũ",
          img: require('@/assets/images/huong_dan_chuyen_data_1.png'),
          show: true,
        },
        {
          title: "Bấm chuyển đổi để bắt đầu tiến trình",
          img: require('@/assets/images/huong_dan_chuyen_data_2.png'),
          show: false,
        },
        {
          title: "NextShop sẽ thông báo khi hoàn thành",
          img: require('@/assets/images/huong_dan_chuyen_data_3.png'),
          show: false,
        },
      ],
      loading: false,
      checkStatusSync: ""
    };
  },

  created() {
    const url_string = window.location.href;
    const lastKeyRouter = url_string.slice(28, 35)
    if (lastKeyRouter == "migrate") {
      // call api information
    }
    this.imgCurrent = this.listStep[0].img

    this.checkLinkedStatusNs1LinkNs2()
    this.startConvertDataNs1ToNs2()
    this.checkSyncStatusNs1LinkNs2()
  },

  methods: {
    changeStep(index) {
      this.imgCurrent = this.listStep[index].img
      this.listStep = this.listStep.map(e => {
        return { ...e, show: false }
      })
      this.listStep[index].show = !this.listStep[index].show
    },
    async checkLinkedStatusNs1LinkNs2 () {
      const response = await SettingService.checkLinkedStatusNs1LinkNs2();
       if(response.success){
          this.statusLink = response.data.isLinked
      }
    },
    
    async startConvertDataNs1ToNs2() {
       const response = await SettingService.convertDataNs1ToNs2();
       if(response.success){
          this.statusConvert = response.data.accepted
          this.nameMerchant = response.data.nsh1MerchantName
          this.nameAccount = response.data.nsh1MerchantUsername
       }
    },
    async checkSyncStatusNs1LinkNs2() {
       const response = await SettingService.checkSyncStatusNs1LinkNs2();
       if(response.success){
          this.checkStatusSync = response.data.syncStatus
       }
    },

    async convertData() {
      try {
        this.loading = true
        const responseStatus = await SettingService.checkSyncStatusNs1LinkNs2();
        if(responseStatus.success){
          //NOT_SENT, REQUEST_RECEIVED, PROCESSING, COMPLETED, ERROR
          if(responseStatus.data.syncStatus !== 'COMPLETED'){
            const response = await SettingService.convertDataNs1ToNs2();
            if (response.success) {
              if(response.data.accepted){
                Swal.fire({
                  title: `<span class="text-danger text-bold">Thành công</span>`,
                  text: `Hệ thống chuyển đổi dữ liệu thành công.`,
                  icon: "success",
                  cancelButtonText: "Quay lại",
                  showCancelButton: true,
                  showConfirmButton: false,
                  backdrop: true,
                  allowOutsideClick: false,
                });
              }
              if(!response.data.accepted){
                Swal.fire({
                  title: `<span class="text-danger text-bold">Thành công</span>`,
                  text: `Không thể liên kết tài khoản. Vui lòng liên hệ hotline: 1900 636 956 để được hỗ trợ.`,
                  icon: "error",
                  cancelButtonText: "Quay lại",
                  showCancelButton: true,
                  showConfirmButton: false,
                  backdrop: true,
                  allowOutsideClick: false,
                });
              }
            }else{
              Swal.fire({
                  title: `<span class="text-danger text-bold">Thành công</span>`,
                  text: `Không thể liên kết tài khoản. Vui lòng liên hệ hotline: 1900 636 956 để được hỗ trợ.`,
                  icon: "error",
                  cancelButtonText: "Quay lại",
                  showCancelButton: true,
                  showConfirmButton: false,
                  backdrop: true,
                  allowOutsideClick: false,
                });
            }
          }
        }
        this.loading = false
      } catch (error) {
        console.log(error);
      }
    },

    linkToNexshopV1() {
      window.open(`https://pos.nextshop.mobi?core_merchant_id=${this.MID}&return_url=${process.env.VUE_APP_URL}/migrate`,'_parent')
    }
  }
};
</script>

<style lang="scss" scoped>
.__box_left {
  .__box_step {
    display: flex;
    cursor: pointer;

    &:last-child {
      .__box_text {
        border-bottom: none;
        width: 100%;
      }
    }

    &_index {
      padding: 6px 12px;
      border-radius: 50%;
      color: #3E69F6;
      margin-right: 8px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #DDDDDD;

      &.active {
        background-color: #3e69f6;
        color: #fff;
      }
    }

    &_title {
      size: 16px;
      font-weight: bold;
      color: #3c3e49;
      height: 32px;
      display: flex;
      align-items: center;
    }

    &_content {
      color: #636678;
      size: 14px;
      font-weight: 400;
    }

    .__box_text {
      border-bottom: 1.5px solid #ddd;
      width: 100%;
      padding: 0px 0px 20px 0px;
      display: flex;
      justify-content: space-between;
    }
  }
}

.__infor_convert {
  padding: 20px 0px 0px;
  margin: 0px;
  border-top: 1px solid #E6F2FF;
  width: 100%;

  &_text {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #141C23;

    &:nth-child(1) {
      margin: 0px;
    }

    span {
      font-weight: 900;
    }
  }
}
.text-green{
  color: #008000!important;
}
.text-danger{
  color: #c33939!important;
}
</style>
